import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TVatCorrectionsResponsePayload,
	TVatCorrectionsStore,
	TVatCorrectionsFilterResponsePayload,
	TCurrenciesResponsePayload,
	TSystemTimeResponsePayload,
	TLoadEUCountriesResponsePayload,
	TExchangeRateResponsePayload,
	TGbpExchangeRateResponsePayload,
	TOrderAvailableCorrectionAmountResponsePayload,
} from './types';

export const getVatCorrectionsState = (state: TStoreState): TVatCorrectionsStore =>
	state.vatCorrections;

export const getVatCorrectionsSelector = getVatCorrectionsState;

// ==========================================:

export const getVatCorrections = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TVatCorrectionsResponsePayload =>
		vatCorrections.vatCorrections,
);

// ==========================================:

export const getVatCorrectionsLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.vatCorrectionsLoading,
);

// ==========================================:

export const getVatCorrectionsFilters = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TVatCorrectionsFilterResponsePayload =>
		vatCorrections.vatCorrectionsFilters,
);

// ==========================================:

export const getVatCorrectionsFiltersLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.vatCorrectionsFiltersLoading,
);

// ==========================================:

export const getSystemTime = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TSystemTimeResponsePayload => vatCorrections.systemTime,
);

// ==========================================:

export const getSystemTimeLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.systemTimeLoading,
);

// ==========================================:

export const getCurrencies = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TCurrenciesResponsePayload => vatCorrections.currencies,
);

// ==========================================:

export const getCurrenciesLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.currenciesLoading,
);

// ==========================================:

export const getEUCountries = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TLoadEUCountriesResponsePayload =>
		vatCorrections.euCountries,
);

// ==========================================:

export const getEUCountriesLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.euCountriesLoading,
);

// ==========================================:

export const getExchangeRate = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TExchangeRateResponsePayload =>
		vatCorrections.exchangeRate,
);

// ==========================================:

export const getExchangeRateLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.exchangeRateLoading,
);

// ==========================================:

export const getGbpExchangeRate = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TGbpExchangeRateResponsePayload =>
		vatCorrections.gbpExchangeRate,
);

// ==========================================:

export const getGbpExchangeRateLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.gbpExchangeRateLoading,
);

// ==========================================:

export const getVatCorrectionsSubmitLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.vatCorrectionSubmitLoading,
);

// ==========================================:

export const getVatCorrectionsSubmitError = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): string => vatCorrections.vatCorrectionSubmitError,
);

// ==========================================:

export const getVatCorrectionsDownloadLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean => vatCorrections.vatCorrectionDownloadLoader,
);

// ==========================================:

export const getOrderAvailableCorrectionAmount = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): TOrderAvailableCorrectionAmountResponsePayload =>
		vatCorrections.orderAvailableCorrectionAmount,
);

// ==========================================:

export const getOrderAvailableCorrectionAmountLoader = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): boolean =>
		vatCorrections.orderAvailableCorrectionAmountLoading,
);

// ==========================================:

export const getOrderAvailableCorrectionAmountError = createSelector(
	[getVatCorrectionsSelector],
	(vatCorrections: TVatCorrectionsStore): string =>
		vatCorrections.orderAvailableCorrectionAmountError,
);
